export const environment = {
  production: false,
  // App Check disabled on staging (no site key) — matches admin-console.
  appCheckSiteKey: '',
  // GitHub OAuth app client id (from the Firebase Auth GitHub provider). Used to
  // deep-link the user to GitHub's app page to grant organization access.
  githubOAuthClientId: 'Ov23liBRbLX387NeXcJk',
  // Google OAuth web client id used by the "connect existing Firebase project"
  // flow (Google Identity Services token client, cloud-platform scope). Ops:
  // create an OAuth web client in the Google Cloud console with authorized
  // JavaScript origins for this app (http://localhost:4200 and the staging
  // host), then paste its client id here. Empty disables the connect flow
  // with a clear error.
  googleOAuthClientId: '519415702791-428hrj78qk8cing5kmmg38i7r2b73afo.apps.googleusercontent.com',
  firebase: {
    apiKey: 'AIzaSyBhZzzyXrLuoxAKIeMV_Ji_oIQGOeorvRc',
    authDomain: 'auth.stg.crewdle.ai',
    databaseURL: 'https://crewdle-sdk-stg-default-rtdb.firebaseio.com',
    projectId: 'crewdle-sdk-stg',
    storageBucket: 'crewdle-sdk-stg.firebasestorage.app',
    messagingSenderId: '519415702791',
    appId: '1:519415702791:web:3176b6deb9fb3c8a3251a2',
    measurementId: 'G-65GE57FYE4',
  },
  adminConsoleUrl: 'https://admin.stg.crewdle.ai',
  authBaseUrl: 'https://auth.stg.crewdle.ai',
  forgeBaseUrl: 'https://forge.stg.crewdle.ai',
};
